import { useEffect, useState, useContext } from "react";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import { getTimeZone } from "api/payments";
import { getCardType } from "api/graphQL_payments";
import { getSingleRole } from "api/graphQL_role";
import { getId, getToken } from "utils/auth";
import { ClientContext } from "ClientProvider";
import SettlementTable from "./components/SettlementTable";
import CrerateSettlementReport from "./components/CrerateSettlementReport";
import { getOrganizationDetails } from "api/graphQL_dashboard";
import { getAllAPIAccessToken } from "api/api_access";
import { useNavigate } from "react-router-dom";

export type SettlementRowObj = {
  id: string;
  name: any;
  logo: string;
  payments: boolean;
  authorization: boolean;
  subscription: boolean;
  payout: boolean;
  refund: boolean;
  apm: boolean;
  is_active: boolean;
  direct_debit?: boolean;
  payin?: boolean;
  token?: boolean;
  created_at: any;
  expiry_date: any;
  api_hit_limit: any;
  status: any;
};

const API_tab = () => {
  const [paymentData, setPaymentData] = useState<SettlementRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [timeZone, setTimeZone] = useState<any>();
  const [allCardType, setCardType] = useState<any>();
  const [allOrgDetails, setAllOrgDetails] = useState<any>();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    if (!token) { navigate("/auth/sign-in", { replace: true }); window.location.reload(); }
  }, [navigate]);

  const fetchAllsettlement = () => {
    setIsLoading(true);
    getAllAPIAccessToken(page, pageSize, searchTexts)
      .then((data) => {
        setPaymentData(data[0] ?? []);
        setTotalPage(data?.[1]?.total_pages);
        setTotalItems(data?.[1]?.total_items);
        setCurrentPage(data?.[1]?.current_page);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const fetchTimeZone = () => {
    getTimeZone().then((data) => setTimeZone(data ?? [])).catch(() => {});
  };

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1); setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  useEffect(() => { fetchAllsettlement(); }, [searchTexts, page, pageSize]);
  useEffect(() => { fetchTimeZone(); }, []);
  useEffect(() => { setPageSize(50); }, [searchTexts]);

  return (
    <div className="api-root">
      {/* Page header */}
      <div className="api-page-header">
        <div className="api-page-title-block">
          <div className="api-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <div>
            <h1 className="api-page-heading">API Access</h1>
            <p className="api-page-sub">Manage API tokens and endpoint permissions</p>
          </div>
        </div>
        {singleRoleData?.[0]?.api?.value?.add_api && (
          <div className="api-page-actions">
            <CrerateSettlementReport
              allOrgDetails={allOrgDetails}
              fetchAllsettlement={fetchAllsettlement}
            />
          </div>
        )}
      </div>

      <SettlementTable
        pageSize={pageSize}
        setPageSize={setPageSize}
        tableData={paymentData}
        fetchAllsettlement={fetchAllsettlement}
        isLoading={isLoading}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        roleData={singleRoleData}
        timeZone={timeZone}
        allCardType={allCardType}
        onValueChange={serchboxValueChange}
        allOrgDetails={allOrgDetails}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .api-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-height: 100vh; display: flex; flex-direction: column; gap: 20px;
        }
        .api-page-header {
          display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px;
        }
        .api-page-title-block { display: flex; align-items: center; gap: 14px; }
        .api-page-icon {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg, #fffbeb, #fef3c7);
          border: 1.5px solid #fde68a;
          display: flex; align-items: center; justify-content: center;
          color: #d97706; flex-shrink: 0;
        }
        .api-page-heading { font-size: 20px; font-weight: 800; color: #0f172a; letter-spacing: -0.4px; margin-bottom: 2px; line-height: 22px; }
        .api-page-sub { font-size: 13px; color: #94a3b8; font-weight: 500; }
        .api-page-actions { display: flex; gap: 10px; align-items: center; }
        @media (max-width: 600px) {
          .api-root { padding: 14px; gap: 14px; }
          .api-page-header { flex-direction: column; align-items: flex-start; }
        }
      `}</style>
    </div>
  );
};

export default API_tab;